import { Listener } from '../listenersStore';

const relevanceProcessingListener: Listener = {
  'refresh/application-relevance': (dispatch: any, action: any) => {
    dispatch({
      type: 'APPLICATION_RELEVANCE_REFRESH_START',
      payload: action.payload,
    });
  },
};

export default relevanceProcessingListener;
